import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { useArtistStory } from "@/api/hooks/useArtistStory";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";
import { ArtistStoryRichText } from "@/components/profile/ArtistStoryRichText";
import { WEBSITE_STORY_HOVER_TEXT } from "@/pages/profile/website-preview/storyPreviewHoverClasses";
import { User } from "lucide-react";

const ArtistEconomyStory = () => {
  const { storyHtml, hasStory } = useArtistStory();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();

  return (
    <div className="flex items-start max-sm:flex-col justify-between gap-10 mb-20 px-4 w-screen">
      <div className="relative w-[523px] max-sm:w-full h-[742px] max-sm:h-[450px] rounded-3xl overflow-hidden bg-[#2C2C2E] flex items-center justify-center">
        {profilePic ? (
          <OptimizedImage
            src={profilePic}
            fill={true}
            unoptimized={true}
            alt={displayName}
            className="object-cover object-top rounded-3xl"
          />
        ) : (
          <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
        )}
      </div>

      <div className="max-w-2xl space-y-4">
        <h2 className="text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text">
          My Story
        </h2>
        {/* <p className="text-[26px]">
          <span className="bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text">
            TOM CRUISE
          </span>
        </p> */}

        <div className="group max-w-full">
          <ArtistStoryRichText
            storyHtml={storyHtml}
            hasStory={hasStory}
            variant="split"
            className={WEBSITE_STORY_HOVER_TEXT}
            maskExactName={displayName}
          />
        </div>

        <button className="bg-gradient-to-b from-[#EC2179] to-[#F16B2E] px-8 py-3 text-lg max-sm:text-sm rounded-xl">
          SEE PRICE & BOOK
        </button>
      </div>
    </div>
  );
};

export default ArtistEconomyStory;
